<template>
    <div>
        <limitless-page-header :title="'Kodtyper'"></limitless-page-header>

        <div class="content">
            <rednax-datatable
                :url="'/vue/product_code_types'"
                :columns="table_columns"
                :filter="table_filter"
                sort-by="ProductCodeTypeName"
                sort-order="asc"
                @updateFilter="table_filter=$event"
                @rowclick="rowClick"
                history
            >
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>

                <template #cell_ProductCodeTypeName="{ row }">
                    <router-link :to="{ name: 'productcodetypes.edit', params: { id: row.ProductCodeTypeID } }">{{ row.ProductCodeTypeName }}</router-link>
                </template>
                <template #cell_IsActive="{ row }">
                    <span v-if="row.IsActive" class="badge badge-success">Aktiv</span>
                    <span v-else class="badge badge-light">Inaktiv</span>
                </template>
            </rednax-datatable>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'ProductCodeTypeList',
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: '#',
                data: 'ProductCodeTypeID',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'ProductCodeTypeName',
                sortable: true,
            },
            {
                header: 'Typ',
                data: 'ProductCodeType',
                sortable: true,
            },
            {
                header: 'Status',
                data: 'IsActive',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'productcodetypes.edit', params: { id: row.ProductCodeTypeID } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'productcodetypes.edit', params: { id: row.ProductCodeTypeID } });
            }
        },
    },
};
</script>
